/** Shared UI words, API error messages and validation messages. */
export default {
  // Generic actions and states
  Save: 'Ruaj',
  Cancel: 'Anulo',
  Delete: 'Fshij',
  New: 'Shto',
  Add: 'Shto',
  Remove: 'Hiq',
  Close: 'Mbyll',
  Back: 'Kthehu',
  Search: 'Kërko',
  'Search…': 'Kërko…',
  Done: 'U krye',
  Saved: 'U ruajt',
  Deleted: 'U fshi',
  Failed: 'Dështoi',
  'Could not save': 'Ruajtja dështoi',
  'Could not delete': 'Fshirja dështoi',
  'Loading…': 'Duke u ngarkuar…',
  'Starting…': 'Duke u nisur…',
  Active: 'Aktiv',
  Name: 'Emri',
  Description: 'Përshkrimi',
  Title: 'Titulli',
  Created: 'Krijuar',
  Language: 'Gjuha',
  'just now': 'tani',
  '{n} min ago': 'para {n} min',
  '{n} h ago': 'para {n} orësh',

  // Navigation
  Dashboard: 'Paneli',
  Network: 'Rrjeti',
  Arrangement: 'Rregullimi',
  Buses: 'Busat',
  Lines: 'Linjat',
  Stations: 'Stacionet',
  Timetables: 'Oraret',
  'Out-of-service areas': 'Zonat jashtë funksionit',
  'Points of interest': 'Pikat e interesit',
  Passengers: 'Pasagjerët',
  News: 'Lajmet',
  Reports: 'Raportet',
  'Push notifications': 'Njoftimet push',
  Advertising: 'Reklamat',
  Campaigns: 'Fushatat',
  'Station ads': 'Reklamat në stacione',
  'Map pins': 'Pinat në hartë',
  System: 'Sistemi',
  'Admin users': 'Përdoruesit admin',
  'Audit log': 'Regjistri i ndryshimeve',
  'My account': 'Llogaria ime',
  'Sign out': 'Çkyçu',
  Administrator: 'Administrator',
  Operator: 'Operator',

  // Entity names (API "… not found" messages)
  Bus: 'Busi',
  Line: 'Linja',
  Station: 'Stacioni',
  Schedule: 'Orari',
  Advertisement: 'Reklama',
  'Pin advertisement': 'Pini reklamues',
  Notification: 'Njoftimi',
  Report: 'Raporti',
  User: 'Përdoruesi',
  Campaign: 'Fushata',
  'Interest point': 'Pika e interesit',
  'Out-of-service area': 'Zona jashtë funksionit',

  // API errors
  '{what} not found': '{what} nuk u gjet',
  'Invalid filter {field}': 'Filtër i pavlefshëm {field}',
  'Wrong e-mail or password': 'E-maili apo fjalëkalimi i gabuar',
  'You do not have permission to do this': 'Nuk keni leje për këtë veprim',
  'This account is not active': 'Kjo llogari nuk është aktive',
  'Images can be at most 10 MB': 'Fotografitë mund të jenë deri në 10 MB',
  'Current password is wrong': 'Fjalëkalimi aktual është i gabuar',
  'No file uploaded': 'Nuk u ngarkua asnjë skedar',
  'Some fields are invalid': 'Disa fusha janë të pavlefshme',
  'Some references do not exist': 'Disa të dhëna të lidhura nuk ekzistojnë',
  'You cannot delete yourself': 'Nuk mund ta fshini veten',
  'You cannot demote or disable yourself': 'Nuk mund ta ulni rolin apo ta çaktivizoni veten',
  'A user with this e-mail already exists': 'Një përdorues me këtë e-mail ekziston tashmë',
  "Delete the campaign's {n} ad(s) first": 'Fshini së pari {n} reklamat e fushatës',
  'Sign in required': 'Duhet të kyçeni',
  'Session expired': 'Seanca ka skaduar',
  'Account disabled': 'Llogaria është çaktivizuar',
  'Too many requests': 'Shumë kërkesa, provoni pak më vonë',
  'Internal Server Error': 'Gabim në server',

  // Validation
  Required: 'E detyrueshme',
  'Invalid value': 'Vlerë e pavlefshme',
  'At least {n} characters': 'Të paktën {n} karaktere',
  'At most {n} characters': 'Më së shumti {n} karaktere',
  'Must be at least {n}': 'Duhet të jetë së paku {n}',
  'Must be at most {n}': 'Duhet të jetë më së shumti {n}',
  'Choose at least {n}': 'Zgjidhni së paku {n}',
  'Choose one of the options': 'Zgjidhni një nga opsionet',
  'Invalid e-mail address': 'Adresë e-maili e pavlefshme',
  'Invalid URL': 'URL e pavlefshme',
  'Invalid url': 'URL e pavlefshme',
  'Invalid email': 'Adresë e-maili e pavlefshme',
  'Invalid date': 'Datë e pavlefshme',
  'Invalid id': 'ID e pavlefshme',
  'Use a hex colour like #e53935': 'Përdorni një ngjyrë hex si #e53935',
  'A timetable for this direction and station already exists':
    'Orari për këtë drejtim dhe stacion ekziston tashmë',
  'Buses are currently on this direction': 'Ka autobusë që janë aktualisht në këtë drejtim',
  'Direction "{name}" would be left with fewer than two stations':
    'Drejtimi "{name}" do të mbetej me më pak se dy stacione',
  'Direction is used by line "{name}"': 'Drejtimi përdoret nga linja "{name}"',
  '{n} bus(es) are assigned to this line': '{n} autobusë janë të caktuar në këtë linjë',
  'A direction needs at least two stations': 'Drejtimi duhet të ketë së paku dy stacione',
  Direction: 'Drejtimi',
  Directions: 'Drejtimet',
  'All directions': 'Të gjitha drejtimet',
  'Move to {line}': 'Kaloje në {line}',
} satisfies Record<string, string>;
